import { SendMessageConfirmationModal } from "@circle-react/components/Chat/sharedV2/SendMessageConfirmationModal";
import { SharePrivateMessageConfirmationModal } from "@circle-react/components/Chat/sharedV2/SharePrivateMessageConfirmationModal";

import type { useChatConfirmationModal } from "./useChatConfirmationModal";

interface ChatConfirmationModalProps extends ReturnType<
  typeof useChatConfirmationModal
> {
  chatParticipantsCount: number;
  handleSubmit: (skipConfirmationModal?: boolean) => Promise<void>;
}

export const ChatConfirmationModal = ({
  chatParticipantsCount,
  handleSubmit,
  setShouldShowPrivateMessageConfirmationOnSubmit,
  shouldShowConfirmationModal,
  shouldShowPrivateMessageConfirmationModal,
  shouldShowPrivateMessageConfirmationOnSubmit,
  toggleConfirmationModal,
  togglePrivateMessageConfirmationModal,
}: ChatConfirmationModalProps) => (
  <>
    <SendMessageConfirmationModal
      shouldShowConfirmationModal={shouldShowConfirmationModal}
      toggleConfirmationModal={toggleConfirmationModal}
      handleSubmit={handleSubmit}
      chatParticipantsCount={chatParticipantsCount}
    />
    {shouldShowPrivateMessageConfirmationModal && (
      <SharePrivateMessageConfirmationModal
        shouldShowPrivateMessageConfirmationModal={
          shouldShowPrivateMessageConfirmationModal
        }
        togglePrivateMessageConfirmationModal={
          togglePrivateMessageConfirmationModal
        }
        handleSubmit={handleSubmit}
        setShouldShowPrivateMessageConfirmationOnSubmit={
          setShouldShowPrivateMessageConfirmationOnSubmit
        }
        shouldShowPrivateMessageConfirmationOnSubmit={
          shouldShowPrivateMessageConfirmationOnSubmit
        }
      />
    )}
  </>
);
